module.exports = __webpack_public_path__ + "img/hp-v2.a938b3ef.svg";